<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="用户名" name="account">
                <a-input v-model:value="searchForm.account" placeholder="请输入用户名"/>
            </a-form-item>
            <a-form-item label="姓名" name="nickname">
                <a-input v-model:value="searchForm.nickname" placeholder="请输入昵称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
        </div>
        <a-table
                :columns="columns"
                :pagination="pagination"
                :data-source="dataSource"
                :loading="loading"
                @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #enable="{record}">
                <switch-btn :value="record.enable" key-field="enable" :switch-url="editUrl"
                            :checkedValue="0" :uncheckedValue="1"
                            :params="{id:record.key}"
                            @ok="loadData"/>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                    <a-popconfirm title="确认要重置密码吗?" @confirm="onResetPass(record.key)">
                        <a>重置密码</a>
                    </a-popconfirm>
                    <a-popconfirm title="确认要删除吗?" @confirm="onDelete(record.key)">
                        <a class="delete">删除</a>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>
    </a-card>
    <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import UserModal from "./components/UserModal";
import {tableListMixin} from "@/mixins";
import {sys_admin} from "@/api/adminService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "用户名", dataIndex: "account", key: "account"},
    {title: "姓名", dataIndex: "nickname", key: "nickname"},
    {title: "启用状态", dataIndex: "enable", key: "enable", slots: {customRender: "enable"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
        UserModal
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: sys_admin.getAdminListData,
            listKeyField: "id",
            deleteUrl: sys_admin.remove,
            editUrl: sys_admin.saveupdate
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('userModal');
        },
        onEdit(record) {
            this.getAction({
                url: sys_admin.getDetail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('userModal', res);
            })
        },
        onResetPass(key) {
            this.postAction({
                url: sys_admin.resetPassword,
                params: {
                    id: key
                },
                returnMsg: true
            }).then(res => {
                this.$message.success(res.msg);
            })
        }
    }
}
</script>

<style scoped>

</style>
